<span class="ui-chip-icon" *ngIf="uiIconType || uiPicture" [style.backgroundColor]="uiIconBgColor" (click)="uiOnChipClick.emit()">
  <i *ngIf="uiIconType" [uiType]="uiIconType" [uiTheme]="uiIconTheme" ui-icon></i>
  <img *ngIf="uiPicture && !uiIconType" [src]="uiPicture" alt="" />
</span>

<div class="ui-chip-dot" *ngIf="uiDotColor" [style.backgroundColor]="uiDotColor" (click)="uiOnChipClick.emit()"></div>
<div class="ui-chip-content" (click)="uiOnChipClick.emit()">
  <ng-content></ng-content>
</div>

<button *ngIf="nzMode === 'closeable'" [tabindex]="-1" (click)="closeTag($event)">
  <i uiType="close-medium" ui-icon></i>
</button>
